import React, {forwardRef, MouseEvent} from "react";
import classNames from "classnames";

import {IconProps, IconSize} from "../icons";


import './TextButton.css';


export interface TextButtonProps {
    onClick: (event: MouseEvent) => void;
    text: string;
    className?: string;
    Icon?: React.ComponentType<IconProps>;
    iconSize?: IconSize;
}

export const TextButton = forwardRef<HTMLAnchorElement, TextButtonProps>((
    {
        className,
        onClick,
        text,
        Icon,
        iconSize = 24
    },
    ref,
) => {
    let content = <>
        {Icon ? (
            <>
                <Icon size={iconSize}/>
                <span className='TextButton__text'>{text}</span>
            </>
        ) : text}
    </>;
    return (
        <a
            ref={ref}
            className={classNames({
                'TextButton title-medium': true,
                [className!]: !!className,
            })}
            onClick={onClick}
        >
            {content}
        </a>
    )
})
